window.mcb.forms.page = function (
  formId,
  prefills,
  pageData
) {
  const _data = pageData;
  const _blocks = [];
  for (let i = 0; i < _data.blocks.length; i++) {
    const block = new window.mcb.forms.block(formId, prefills, _data.blocks[i]);
    if (!block.isEmpty()) {
      _blocks.push(block);
    }
  }

  const isEmpty = function () {
    return _blocks.length === 0 && _data.caption === null;
  }

  return _ = {
    blocks: _blocks,
    isEmpty: isEmpty,
    render: function (target, message, enrichFieldFunction) {
      if (isEmpty()) {
        return;
      }

      const element = document.createElement('div');
      element.classList.add(window.mcb.forms.constants.pages.classBase);
      target.append(element);

      if (_data.caption !== null) {
        const head = document.createElement('h2');
        element.append(head);
        head.classList.add(window.mcb.forms.constants.pages.classBase + '--title');
        head.append(_data.caption);
      }

      if (message !== null) {
        element.append(message);
      }

      const blocksElement = document.createElement('div');
      blocksElement.classList.add(window.mcb.forms.constants.blocks.collectionClass);
      element.append(blocksElement);

      for (let block of _blocks) {
        block.render(blocksElement, enrichFieldFunction);
      }
    },
    onRendered: function () {
      for (let block of _blocks) {
        block.onRendered();
      }
    }
  };
};
